import { parseLocalDate } from "@components/utils/effectiveDated";
import { formatPayRangeAmount } from "@components/utils/formatPayRangeAmount";

const ISO_PARTS = /^(\d{4})-(\d{2})-(\d{2})/;

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** Parses a calendar day; rejects impossible ISO days (2026-02-31) instead of rolling them over. */
function parseDay(value) {
  const date = parseLocalDate(value);
  if (!date) return null;
  const iso = typeof value === "string" ? ISO_PARTS.exec(value.trim()) : null;
  if (iso && (date.getMonth() + 1 !== Number(iso[2]) || date.getDate() !== Number(iso[3]))) {
    return null;
  }
  return date;
}

/** exIQtive standard date: "MMM D, YYYY" (May 1, 2025). "" for empty or invalid input. */
export function formatFairPayDate(value) {
  const date = parseDay(value);
  if (!date) return "";
  return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}

/** Month and year only: "MMM YYYY" (Feb 2026). "" for empty or invalid input. */
export function formatFairPayMonthYear(value) {
  const date = parseDay(value);
  if (!date) return "";
  return `${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

/** Version label with an uppercase V: 3 -> "V3", "v3" -> "V3". "" when there is no version. */
export function formatFairPayVersion(version) {
  if (version == null || version === "") return "";
  return `V${String(version).trim().replace(/^v/i, "")}`;
}

/** Uppercases the V of a version label or code: "v1" -> "V1", "P-1234.v3" -> "P-1234.V3". */
export function normalizeFairPayVersionLabel(label) {
  if (label == null) return "";
  return String(label).replace(/(^|\.)v(?=\d|\?)/, "$1V");
}

/** Plan or range code with its version: ("P-1234", 3) -> "P-1234.V3". */
export function formatFairPayVersionCode(code, version) {
  const versionLabel = formatFairPayVersion(version);
  if (!code) return versionLabel;
  return `${code}.${versionLabel || "?"}`;
}

/** Compact amount with uppercase K / M and an optional currency prefix: (92000, "$") -> "$92K". */
export function formatFairPayCompactAmount(value, symbol = "") {
  if (value == null || value === "") return "";
  const body = formatPayRangeAmount(value);
  return body === "-" ? "" : `${symbol}${body}`;
}
